<!-- Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams -->
<template>
	<div class="k-main-division-wrapper k-main-classes">
		<AdminList :config="list_config"/>
		<router-view></router-view>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import AdminList from './AdminList'

export default {
	components: { AdminList },
	
	computed: {
		...mapState(['tools_for_subdomain_admins','site_config']),

		list_config() {
			let customized_tabs = this.site_config.customized_tabs

			return {
				id: 'admin',
				icon: customized_tabs.admin?.icon || 'fas fa-cog',
				title: customized_tabs.admin?.title || 'Site Admin Tools'
			}
		},
	},
	
	methods: {
		police_tools() {
			// keep non-admins out of admin tools
			if (!vapp.has_admin_right('su')) {
				// subdomain admins can see these tools (but will have limited rights on those tools)
				if (this.tools_for_subdomain_admins.includes(tool)) {
					if (vapp.has_admin_right('subdomain_admin')) return
				}
				this.$router.push({ path: '/home' })
			}
		}
	}
}
</script>

<style lang="scss">
.k-main-classes {
	position:relative;
}
</style>
